import React, { useEffect, useState } from 'react';
import add from './assets/Add.svg';
import remove from './assets/remove.svg';
import './VerticalChapterListing.css'
import { Version } from '../types/presentation';
import { ImageActionState } from './ChapterEditorMain';

interface Chapter {
    id: number;
    title: string;
    time: number;
}

interface Props {
    chapters: Chapter[];
    // selectedChapters: number[] | null;
    selectedChapters: ImageActionState;
    toggleChapterSelection: (id: number, type: "add" | "remove") => void;
    dataFromChild: string;
    singleVersion: Version | null;
    details: { [key: number]: { title: string; topic: string } };
    setDetails: React.Dispatch<React.SetStateAction<{ [key: number]: { title: string; topic: string } }>>;
    setHasModification: (value: boolean) => void;
    seek: (time: number) => void;
}

const VerticalChapterListing: React.FC<Props> = ({
    chapters,
    selectedChapters,
    toggleChapterSelection,
    dataFromChild,
    singleVersion,
    details,
    setDetails,
    setHasModification,
    seek
}) => {
    const [hoveredChapter, setHoveredChapter] = useState<number | null>(null);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    useEffect(() => {
        setSelectedIds(selectedChapters.selected ?? []);
    }, [selectedChapters]);

    const HandleInputs = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        try {

            setHasModification(true);
            const { name, value } = e.target;
            setDetails(prev => ({
                ...prev,
                [id]: {
                    ...prev[id],
                    [name]: value
                }
            }));
        } catch (error) {
            console.error(error);
        }
    };

    const HandleSelection = (id: number, type: "add" | "remove") => {
        try {

            toggleChapterSelection(id, type);

            setSelectedIds((prevSelectedIds) => {
                if (type === "remove") {
                    const indexInChapters = chapters.findIndex((chapter) => chapter.id === id);
                    if (indexInChapters !== -1) {
                        const chaptersToRemove = chapters.slice(indexInChapters);
                        const idsToRemove = chaptersToRemove.map(chapter => chapter.id);
                        return prevSelectedIds.filter(selectedId => !idsToRemove.includes(selectedId));
                    }
                    return prevSelectedIds.filter(selectedId => selectedId !== id);
                } else if (type === "add") {
                    return prevSelectedIds.includes(id) ? prevSelectedIds : [...prevSelectedIds, id];
                }
                return prevSelectedIds;
            });

        } catch (error) {
            console.error(error);
        }
    };
    
    const lastOne = chapters[chapters.length - 1];
    const value = lastOne.time
    console.log(value, "lastOne time means duratio");
    
    return (
        <div
            className="vertical-chap d-flex flex-column w-100"
            style={{
                maxHeight: dataFromChild === 'vertical' ?
                    window.innerWidth >= 1920 ? '328px' :
                        window.innerWidth > 1366 ? '210px' :
                            window.innerWidth >= 1024 ? '500px' :
                                window.innerWidth <= 400 ? '260px' :
                                    window.innerWidth > 400 ? '260px' :
                                        '450px' : 'none',
                overflowY: dataFromChild !== 'vertical' ? 'hidden' : 'auto',
            }}
        >
            {selectedChapters.chapters.map((chapter, index) => {
                const chapterTitle =
                    details[chapter.id]?.title !== undefined
                        ? details[chapter.id].title
                        : singleVersion?.thumbnails?.[chapter.id]?.title || "";

                const chapterDescription =
                    details[chapter.id]?.topic !== undefined
                        ? details[chapter.id].topic
                        : singleVersion?.thumbnails?.[chapter.id]?.description || "";

                return (
                    <div
                        key={chapter.id}
                        className="chapter-item d-flex flex-column flex-md-row align-items-start justify-content-between w-100 mt-2 pr-3"
                    >
                        {/* Label Section */}
                        <div
                            className="d-flex align-items-center mb-2 mb-md-0 ml-4"
                            style={{ minWidth: '100px', cursor: 'pointer' }}
                            onClick={() => {
                                const chap = chapters.find(c => c.id === chapter.id);
                                if (chap) {
                                    seek(chap.time / 1000);
                                }
                            }}
                        >
                            <h5
                                className="p-2 text-nowrap mb-0 text-white"
                                style={{ fontSize: "14px" }}
                            >
                                chapter {index + 1}
                            </h5>
                        </div>

                        {/* Input Section */}
                        <div className="d-flex flex-column flex-md-row w-100">
                            <div
                                className="mb-2 mb-md-0 position-relative"
                                style={{ flex: "0 0 25%", maxWidth: "25%" }}
                                onMouseEnter={() => setHoveredChapter(chapter.id)}
                                onMouseLeave={() => setHoveredChapter(null)}
                            >
                                <input
                                    type="text"
                                    name="title"
                                    value={chapterTitle}
                                    onChange={(e) => HandleInputs(e, chapter.id)}
                                    className="w-100 p-2 text-white"
                                    style={{
                                        border: 'none',
                                        opacity: hoveredChapter === chapter.id ? 0.7 : 1,
                                        backgroundColor: selectedIds.includes(chapter.id) ? '#3f6d8c' : '#666a74',
                                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                                    }}
                                />
                                {hoveredChapter === chapter.id && (
                                    <span
                                        className="position-absolute d-flex"
                                        style={{
                                            top: "50%",
                                            right: "0",
                                            transform: "translateY(-50%)",
                                        }}
                                    >
                                        {selectedIds.includes(chapter.id) ? (
                                            <img
                                                src={remove}
                                                alt="Remove"
                                                className="btn cursor-pointer"
                                                onClick={() => HandleSelection(chapter.id, "remove")}
                                            />
                                        ) : (
                                            <img
                                                src={add}
                                                alt="Add"
                                                className="btn cursor-pointer"
                                                onClick={() => HandleSelection(chapter.id, "add")}
                                            />
                                        )}
                                    </span>
                                )}
                            </div>

                            {/* Second Input - takes the remaining space */}
                            <div className="flex-grow-1 mt-2 mt-md-0 ml-md-4">
                                <input
                                    type="text"
                                    name="topic"
                                    value={chapterDescription}
                                    onChange={(e) => HandleInputs(e, chapter.id)}
                                    className="w-100 p-2 text-white"
                                    style={{
                                        border: 'none',
                                        backgroundColor: selectedIds.includes(chapter.id) ? '#3f6d8c' : '#666a74',
                                        opacity: hoveredChapter === chapter.id ? 0.7 : 1,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default VerticalChapterListing;